import { useTrans } from "@/translations";

import type { WasteStreamWithUse } from "../types";
import { StreamBadge } from "./streamBadge";

type Props = { label: string; streams: WasteStreamWithUse[] };

export const StreamGroup: React.FC<Props> = ({ label, streams }) => {
  const { t } = useTrans();

  if (!streams.length) {
    return null;
  }

  return (
    <div>
      <div className="text-grey5 mb-[12px] text-[11px] font-bold tracking-[0.05] uppercase">
        {t(label)}
      </div>
      <div className="flex flex-wrap gap-[8.25px]">
        {streams.map((s) => (
          <StreamBadge key={s.name} stream={s} />
        ))}
      </div>
    </div>
  );
};
